import { apiHelper } from '@/utils'
import { API } from '@/constants'


export const vehicleBrandService = {
    getAllBrands,
    getBrand,
    updateBrand,
    updateBrandStatus 
};

const MODULE = {
    BRAND: 'vehicle-brands',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllBrands(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.BRAND}`, requestOptions)
  }

  export function getBrand(id) {
   
    return apiHelper(API_URL).get(`/${MODULE.BRAND}/${id}`)
  }

  export function updateBrand(data) {

    const requestOptions = {
      name: data.name,
    }
      return apiHelper(API_URL).post(`/${MODULE.BRAND}`, requestOptions)
  }



  export function updateBrandStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.BRAND}/${data.id}`, requestOptions)
    
  }